import React from 'react'

import Text from './Text'
import News from './News'
import Showcase from './Showcase'

import styles from './Sayonara.module.css'

const Sayonara = () => (
  <div className={styles.container}>
    <div className={styles.roofContainer}>
      <div className={styles.roof} />
    </div>
    <div className={styles.intro}>
      <div className={styles.content}>
        <div className={styles.pitch}>
          <div className={styles.centerer}>
            <h1>Time to untie</h1>
            <Text size="large" className={styles.copy}>
              We started Bowtie in late 2014; we had a dream to create delightful digital products while also at the same time being able to work more freely, following our passions, and pursuing new technologies that we otherwise couldn't have done as easily.
            </Text>
          </div>
          <div className={styles.contentBg}>
            <div className={styles.centerer}>
              <Text size="large" className={styles.copy}>
                All we had was friendship, two rented desks, and a few leads. And let me tell you, we've been busy - at times too busy, but that was our own fault with struggles to just say "No" from time to time. However, most importantly, we also gave each other time to focus on family and the things that matter outside what's presented at WWDC each year.
              </Text>
              <Text size="large" className={styles.copy}>

                We, of course, also had a few hiccups, as you do, trying to grow a successful business with close friends. But oh lord, it was a fun ride! Working together as a team gave this adventure so much joy and gave us so many unforgettable memories.
              </Text>
              <Text size="large" className={styles.copy}>

                Looking back on another note, we can be so immensely proud of what we delivered to clients, from the smallest micro-interaction to large-scale backends.
              </Text>
              <Text size="large" className={styles.copy}>

                And to wrap up this untying, there is no need to describe how 2020 was for most people. For Bowtie as a business – it meant the start of something new, new beginnings, and parted journeys to endeavor in the future. It was simply time to move on, in one way or another. This business passion project has come to an end, but our friendships stay strong.
              </Text>
              <Text size="large" className={styles.copy}>

                We want to take this opportunity to thank everyone who supported us, believed in us and gave us a chance to show what we can do.
              </Text>
              <Text size="large" className={styles.copy}>

                From the bottom of our hearts, thank you all.
              </Text>
              <Text size="large" className={styles.copy}>

                Marcus, Simon &amp; Edward
              </Text>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
)


export default Sayonara



// WEBPACK FOOTER //
// ./src/components/Sayonara.js